module.exports = __webpack_public_path__ + "img/settings_icon.5fed45e5.svg";